



























import { Vue, Component, Prop } from 'vue-property-decorator';
import OdataResource from '@/modules/api/OdataResource';
import IFormField from '@/modules/form/interfaces/IFormField';

// TODO: try to use multiselect
@Component({
    name: 'CountrySelect',
    components: {},
})
export default class CountrySelect extends Vue {
    @Prop() public formField!: IFormField;
    @Prop() public resourceUrl!: string;
    private errored = false;
    private loading = false;
    private resources: object[] = [];
    private resourceEndpoint: OdataResource<object> = new OdataResource<object>(
        this.resourceUrl,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
        this.onResourcesLoaded,
    );

    private mounted() {
        this.resourceEndpoint.baseUrl = this.resourceUrl;
        this.resourceEndpoint.getResources('');
    }

    private onError(error: unknown) {
        console.error(error);
        this.errored = true;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onResourcesLoaded(resources: any[]) {
        // TODO: Add autocomplete functionality
        this.resources = resources
            .map(x => ({ text: x.name_en, value: x.name_en }))
            .sort((x, y) => x.text.toLowerCase().localeCompare(y.value.toLowerCase()));
        // this.resources.unshift({ text: null, value: this.formField.Tooltip, Hidden: true });
    }

    private onResourceLoading() {
        this.loading = true;
    }

    private onResourceLoadingFinished() {
        this.loading = false;
    }
}
